import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "f5ace29f-d66c-4670-b93b-bc5468855cdf",
  publicId: "9",
  name: "Acoustic intensity and losses",
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
  difficulty: 1,
};

export default lesson;
